var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758155857327,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 65975,
    width: 20,
    height: 20,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M992 96H576V75.9c0-40.3-36.9-70.6-76.4-62.8l-448 88.7C21.6 107.7 0 134 0 164.6v694.7c0 30.6 21.7 57 51.8 62.8l448 87.1c39.5 7.7 76.2-22.6 76.2-62.8V928h416c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32zM134.9 662.5l75.4-142.1c2.4-4.5 2.5-9.9 0.3-14.5l-69.5-143c-2.3-4.8 0.6-10.5 5.8-11.4l45.2-7.9c7.3-1.3 14.5 2.6 17.5 9.4l38.9 90.6c3.7 8.8 6.9 18.5 9.6 29.3h0.8c2.8-10 6.3-20.6 10.5-31.9l52.1-113.2c2.2-4.8 6.6-8.2 11.8-9.1l67.1-11.8c6.6-1.2 11.6 5.8 8.4 11.7L306.9 504.1c-2.6 4.8-2.6 10.7 0 15.5l104.8 189c3.3 5.9-1.8 12.9-8.4 11.8l-72.7-12.8c-5.2-0.9-9.6-4.3-11.8-9.1l-56.5-123.7c-2-4.5-4.1-12.5-6.3-24h-0.8c-1.1 5.6-3.5 13.5-7.2 23.9l-47.3 98.4c-3.1 6.5-10.1 10.1-17.2 8.8l-43-7.5c-5.3-1.2-8.2-7.1-5.6-11.9zM960 856c0 4.4-3.6 8-8 8H576v-88c0-4.4 3.6-8 8-8h96c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-96c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h96c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-96c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h96c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-96c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h96c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-96c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h96c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-96c-4.4 0-8-3.6-8-8v-88h376c4.4 0 8 3.6 8 8v688z",
    "p-id": 65976
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M760 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H760zM760 368c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H760zM760 480c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H760zM760 592c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H760zM760 704c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H760z",
    "p-id": 65977,
    fill: "#388e3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.ff6c5a62.svg";
export { ForwardRef as ReactComponent };